import $ from 'jquery';
import React from 'react';
import { Provider } from 'react-redux';
import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import ReactDOM from 'react-dom';
import * as API from './api';
import { error } from 'plugins/toastr';
import CaseTransferModal from './components/CaseTransferModal';
import reducers from './reducers';
import { withCurrentReferer } from 'plugins/contextual-back';

export function displayCaseTransferModal(callback) {
  const createLogger = require('redux-logger');
  const logger = createLogger({
    collapsed: true,
  });

  const middleware = [thunk, logger];
  const enhancers = [];

  const store = createStore(
    reducers,
    compose(applyMiddleware(...middleware), ...enhancers)
  );
  const root = document.getElementById('bt-case-transfer');
  const modalRoot = document.getElementById('modal-root-small');
  const id = root.getAttribute('data-id');
  const customerId = root.getAttribute('data-customer');
  $(root).removeAttr('href');

  const modal = ReactDOM.render(
    <Provider store={store}>
      <CaseTransferModal
        caseId={parseInt(id, 10)}
        currentCustomerId={parseInt(customerId, 10)}
      />
    </Provider>,
    modalRoot
  );

  displayModal(modal, callback);

  const confirmButton = document.getElementById('bt-confirm');
  const cancelButton = document.getElementById('bt-cancel');
  if (confirmButton) {
    confirmButton.onclick = () => {
      confirmButton.classList.add('disabled');
      confirmButton.classList.add('loading');
      cancelButton.classList.add('disabled');
      API.update(id, store.getState().form).then(
        res => window.location.replace(withCurrentReferer(res.url)),
        err => {
          confirmButton.classList.remove('disabled');
          confirmButton.classList.remove('loading');
          cancelButton.classList.remove('disabled');
          handleError(err, store);
        }
      );
    };
  }
}

function dispatchErrors(store, error) {
  const errors = Object.keys(error)
    .map(key => {
      return key.substring(4);
    })
    .filter(e => e !== null);

  store.dispatch({
    type: 'errors',
    payload: errors,
  });
}

function handleError(err, store) {
  console.log('Error attempting to save case', err);
  if (err.res.status === 400) {
    // Handling errors properly
    err.res.json().then(json => dispatchErrors(store, json));
  } else {
    error('Une erreur est survenue pendant le transfert de chantier');
  }
}

function displayModal(modal, callback) {
  // Appending content to body
  $(document.body).append(modal);

  // Handling approve button
  const $modal = $('#modal-root-small');

  $modal
    .modal({
      onApprove: element => {},
    })
    .modal('show');
}



// WEBPACK FOOTER //
// ./src/modules/saas/aast/common/modals/case-transfer/index.js